import zipState from "zip-state";
import { NO_US_ZIPCODE } from "src/utils/normalizePostalCode";

/**
 * Canonical non-US sentinel for the `usState` eligibility answer (mirrors the
 * user-model `usState` question). Distinct from {@link NO_US_ZIPCODE}, which is
 * the sentinel stored on the `zipcode` answer.
 */
export const NO_US_STATE = "noUsState";

/**
 * Derives the canonical 2-letter `usState` value from a saved `zipcode` answer,
 * mirroring the historical zip->state derivation: the {@link NO_US_ZIPCODE}
 * sentinel (or a zip that maps to no US state) becomes {@link NO_US_STATE};
 * otherwise the USPS state code from `zipState`.
 *
 * Returns `undefined` when there is no zipcode to derive from, so callers can
 * skip reconciling.
 */
export function deriveUsStateFromZipcode(
  zipcode: string | undefined
): string | undefined {
  if (zipcode === undefined) {
    return undefined;
  }
  if (zipcode === NO_US_ZIPCODE) {
    return NO_US_STATE;
  }
  return zipState(zipcode) ?? NO_US_STATE;
}
